import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";

interface Props {
    modalId: string;
    showOnPageLoad: boolean;
    data: any;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modalId: { type: String, required: true },
    showOnPageLoad: { type: Boolean, required: true },
    data: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    modalId: string;
    showOnPageLoad: boolean;
    data: any;
}



const open = ref(false);

const closeModal = () => {
    open.value = false;

    setCookie(`livelaud-session-${props.modalId}`, "true");
};

const setCookie = (name: string, value: string, days?: number) => {
    if (days) {
        var expires = "";
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + "; path=/";
    }
};

const getCookie = (name: string) => {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
};

const handleClick = () => {
    setCookie(`livelaud-session-${props.modalId}`, "true");
};

onMounted(() => {
    if (props.showOnPageLoad && !getCookie(`livelaud-session-${props.modalId}`)) {
        open.value = true;
    }
});

const __returned__ = { props, open, closeModal, setCookie, getCookie, handleClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})